var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5306 5.47L10.0306 1.97C9.96097 1.90026 9.87826 1.84494 9.78721 1.80719C9.69616 1.76944 9.59856 1.75 9.5 1.75H3.5C3.16848 1.75 2.85054 1.8817 2.61612 2.11612C2.3817 2.35054 2.25 2.66848 2.25 3V14C2.25 14.3315 2.3817 14.6495 2.61612 14.8839C2.85054 15.1183 3.16848 15.25 3.5 15.25H12.5C12.8315 15.25 13.1495 15.1183 13.3839 14.8839C13.6183 14.6495 13.75 14.3315 13.75 14V6C13.75 5.80124 13.6711 5.61062 13.5306 5.47ZM10 4.0625L11.4375 5.5H10V4.0625ZM3.75 13.75V3.25H8.5V6.25C8.5 6.44891 8.57902 6.63968 8.71967 6.78033C8.86032 6.92098 9.05109 7 9.25 7H12.25V13.75H3.75Z",
    fill: "#0B1A29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.692a0193e0f447b71662f62ceadc3c56.svg";
export { ForwardRef as ReactComponent };